import { connect } from 'react-redux';
import WorkingHours from './WorkingHours';
import { getUser, workingHoursLoading } from '../../../store/selectors/user.selector';
import { updateWorkingHours } from '../../../store/actions/user.actions';

const mapDispatchToProps = { updateWorkingHours }; 

const mapStateToProps = (state) => { 
    const users = getUser(state);
    const loading = workingHoursLoading(state);
    return { users, loading };
 };

export default connect(mapStateToProps, mapDispatchToProps)(WorkingHours);